import Vue from "vue";
import Vuetify, { VCard, VRating, VToolbar } from "vuetify/lib";
import { Ripple } from "vuetify/lib/directives";

Vue.use(Vuetify, {
  components: {
    VCard,
    VRating,
    VToolbar
  },
  directives: {
    Ripple
  }
});
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/dist/vuetify.min.css";

export default new Vuetify({
  icons: {
    iconfont: "mdi" // default - only for display purposes
  },
  theme: {
    dark: false,
    themes: {
      light: {
        primary: "#8FAE2D"
      },
      dark: {
        primary: "#8FAE2D"
      }
    }
  }
});
